import { render, staticRenderFns } from "./Ilustra.vue?vue&type=template&id=490795c4&scoped=true&"
import script from "./Ilustra.vue?vue&type=script&lang=ts&"
export * from "./Ilustra.vue?vue&type=script&lang=ts&"
import style0 from "./Ilustra.vue?vue&type=style&index=0&id=490795c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490795c4",
  null
  
)

export default component.exports